
'use strict';

// Keep references compact while preserving direct citation navigation.
function revealReference(hash) {
  if (!/^#source-\d+$/.test(hash)) return;
  const target = document.getElementById(hash.slice(1));
  if (!target) return;
  document.getElementById('references').open = true;
  requestAnimationFrame(() => target.scrollIntoView({block: 'start'}));
}
document.querySelectorAll('a[href^="#source-"]').forEach(link => {
  link.addEventListener('click', () => { document.getElementById('references').open = true; });
});
window.addEventListener('hashchange', () => revealReference(location.hash));
revealReference(location.hash);

// Formspark action URLs are public by design. Never embed API secrets here.
const SUBMISSION_ENDPOINT = 'https://submit-form.com/JYRQdoGPM';
const form = document.getElementById('experience-form');
const fields = document.getElementById('form-fields');
const submitButton = document.getElementById('submit-button');
const status = document.getElementById('form-status');
const endpointReady = /^https:\/\//.test(SUBMISSION_ENDPOINT);
if (endpointReady) {
  fields.disabled = false;
  submitButton.disabled = false;
}
form.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (!endpointReady || !form.reportValidity()) return;
  const payload = Object.fromEntries(new FormData(form).entries());
  payload.contact_permission = document.getElementById('contact-permission').checked;
  payload.intake_consent = document.getElementById('intake-consent').checked;
  payload._email = {subject: 'New Kaiser Allergy Watch experience submission'};
  fields.disabled = true;
  submitButton.textContent = 'Submitting…';
  status.textContent = '';
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(SUBMISSION_ENDPOINT, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(payload), credentials: 'omit',
      referrerPolicy: 'no-referrer', signal: controller.signal
    });
    if (!response.ok) throw new Error('Submission failed');
    form.reset();
    form.hidden = true;
    const success = document.getElementById('success');
    success.hidden = false;
    success.focus();
  } catch (_) {
    status.textContent = 'We could not confirm receipt. Your entries remain here. Retrying may create a duplicate if the first submission arrived.';
    fields.disabled = false;
    submitButton.textContent = 'Try submitting again';
  } finally { clearTimeout(timeout); }
});
// Reveal privacy details when reached through an internal link or URL fragment.
function revealPrivacy() {
  if (location.hash === '#privacy') document.getElementById('privacy').open = true;
}
window.addEventListener('hashchange', revealPrivacy);
document.querySelectorAll('a[href="#privacy"]').forEach(link => link.addEventListener('click', () => {
  document.getElementById('privacy').open = true;
}));
revealPrivacy();
